import { Vehicle } from '@esportal/portal-service';
import { Container, ContainerPadding, CTA } from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import { FocusLayerSizeV2, ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';
import React from 'react';
import { PortalContext } from '../../context/portal-context';
import { AlertType } from '../alerts/alerts-type';
import { VWBookParticipa } from './promotions/VWBook26/vwBookParticipa';
import { ElClasicoParticipa } from './promotions/el-clasico/el-clasico-participa';
import { GTIDayParticipa } from './promotions/gti-day-26/gti-day-layer-participa';
import { GTIDayVipParticipa } from './promotions/gti-day-26/gti-day-vip-layer-participa';
import { LaLigaParticipa } from './promotions/laLiga/laLigaParticipa';
import { MasterWinnerLayer } from './promotions/master-carretera-26/master-carretera-winner';

export interface DefaultPromotionData {
	phonePrefix: string;
	phoneMobile: string;
	originDeviceType: string;
	formUrl: string;
	originTrackingCode: string;
}

export const PromotionPopupLayer: React.FC<{
	alertType: AlertType | null;
	vehicle?: Vehicle;
	isPromotionPopupVisible: boolean;
	setIsPromotionPopupVisible: React.Dispatch<React.SetStateAction<boolean>>;
	promotionLayerRef: React.RefObject<HTMLElement>;
}> = ({ alertType, vehicle, isPromotionPopupVisible, setIsPromotionPopupVisible, promotionLayerRef }) => {
	const { layerManager } = React.useContext(PortalContext);
	const portalContext = React.useContext(PortalContext);

	const handleClose = () => {
		setIsPromotionPopupVisible(false);
		if (promotionLayerRef?.current) {
			(promotionLayerRef.current as any).close();
			return ((promotionLayerRef.current as any) = null);
		}
		return;
	};

	const renderPromotionLayer = () => (
		<PortalContext.Provider value={portalContext}>
			<Container
				horizontalAlign={'flex-end'}
				padding={{
					top: ContainerPadding.dynamic0100,
					right: ContainerPadding.dynamic0100,
					bottom: ContainerPadding.dynamic0100,
				}}
			>
				<CTA
					tag="button"
					emphasis="tertiary"
					onClick={handleClose}
					aria-label="Close pop-up"
					icon={<Close variant="default" aria-hidden />}
				/>
			</Container>
			{(() => {
				switch (alertType) {
					case AlertType.VWBook26_Participa:
						return <VWBookParticipa />;
					case AlertType.LaLiga26_Open:
						return <LaLigaParticipa />;
					case AlertType.ElClasico26_Open:
						return <ElClasicoParticipa />;
					case AlertType.Masters26_Winner:
						return <MasterWinnerLayer />;
					case AlertType.GTIDay26_Open:
						return <GTIDayParticipa />;
					case AlertType.GTIDayVIP26_Open:
						return <GTIDayVipParticipa />;
					default:
						return <></>;
				}
			})()}
		</PortalContext.Provider>
	);

	React.useEffect(() => {
		let layer: any;
		if (promotionLayerRef.current) {
			(promotionLayerRef.current as any).close();
			(promotionLayerRef.current as any) = null;
		}

		// Usar isPromotionPopupVisible para controlar la apertura
		if (isPromotionPopupVisible) {
			layer = layerManager.openFocusLayer(
				renderPromotionLayer,
				{},
				{
					size: FocusLayerSizeV2.A,
					shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
				},
			);
			(promotionLayerRef.current as any) = layer;
		}

		return () => {
			if (layer) {
				layer.close();
				(promotionLayerRef.current as any) = null;
			}
		};
	}, [alertType, layerManager, promotionLayerRef, portalContext, isPromotionPopupVisible, vehicle]);

	return null;
};
